import styled from "styled-components";

export const Back = styled.div`
  border-top: 3px solid gray;
  background-color: #cccccc;
  width: 100%;
`;

export const Container = styled.div`
  width: 80%;
  margin: auto;
  min-height: 400px;
  display: block;
  text-align: center;
  @media (max-width: 768px) {
    display: block;
    width: 100%;
    text-align: center;
  }
`;

export const Title = styled.h1`
  display: block;
  font-family: "Nothing You Could Do", cursive;
  font-size: 5rem;
  font-weight: 900;
  padding-top: 100px;
  margin-bottom: 40px;
`;

export const Parent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  @media (max-width: 768px) {
    display: block;
    width: 100%;
    text-align: center;
  }
`;

export const Name = styled.p`
  font-family: "Caveat", cursive;
  font-size: 4rem;
  padding: 10px;
  line-height: 1.5;
  & > span {
    font-size: 3rem;
    line-height: 1;
    display: block;
  }
`;

export const Child = styled.div`
  display: block;
`;

export const Font = styled.p`
  font-size: 2rem;
  font-weight: 700;
  font-family: "Allerta Stencil", sans-serif;
`;

export const ChildTwo = styled.div`
  display: block;
`;

export const Mail = styled.p`
  font-size: 2rem;
  @media (max-width: 768px) {
    padding-bottom: 40px;
    margin-bottom: 0;
  }
`;
